import { render, staticRenderFns } from "./CommissionsTableDetail.vue?vue&type=template&id=5324c974&scoped=true"
import script from "./CommissionsTableDetail.vue?vue&type=script&lang=ts"
export * from "./CommissionsTableDetail.vue?vue&type=script&lang=ts"
import style0 from "./CommissionsTableDetail.vue?vue&type=style&index=0&id=5324c974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5324c974",
  null
  
)

export default component.exports